const proyectos = [
    {
        titulo: "Hecho x Nosotros",
        desc: [
            `ONG destinada en ayudar a los pueblos artesanos consumiendo sus productos, ayudando simultaneamente a la protección del medio ambiente generando consiencia en productos de indumentaria nocivos.`,
             `Nuestros objetivos fueron poder crear más visualización y conseguir donantes para la causa.`
            ],
        rol: "UX Researcher",
        tiempo: "6 meses",
        team: "3 UX/UI - 1 UX Research",
        tecnologias: [
            require("../assets/img/programasYEst/figma.png"),
            require("../assets/img/programasYEst/ilustrador-adobe.png"),
            require("../assets/img/programasYEst/premier-pro.png"),
        ],
        portada: require("../assets/img/portafolio/HxN-B.webp"),
        presentacion: "",
    },
    {
        titulo: "YGG",
        desc: ["Red social para el metarso. YGGdrassil planea ser una plataforma que puede ser usada en cualquier dispositivo, considerando los de realidad aumentada y realildad virtual. Busca conectar todos los mundos por medio de esta plataforma, manteniendo conectada a las personas sin importar la realidad en la que este.", "Nuestros objetivos fueron: comprender las necesidades futuras del usuario bajo estas condiciones y proponer funciones tanto innovadoras como eficientes."],
        rol: "Diseñador UX/UI",
        tiempo: "4 meses",
        team: "2 UX/UI (Proyecto Propio)",
        tecnologias: [
            require("../assets/img/programasYEst/figma.png"),
            require("../assets/img/programasYEst/adobe-photoshop.png"),
            require("../assets/img/programasYEst/ilustrador-adobe.png"),
        ],
        portada: require("../assets/img/portafolio/YGG-B.webp"),
        presentacion: "https://www.behance.net/gallery/157749319/Social-Media-for-the-metaverse",
    },
    {
        titulo: "PRO-grama",
        desc: ["PRograma es una plataforma de estudio para programadores que busca simplificar el metodo de aprendisaje dando la oportunidad de practicar los codigos durante las practicas.", "Nuestros objetivos fueron: mejorar la retención de los usuarios para terminar los cursos.Por arriba del 50%,, considerando que ese es el porcentaje de retención de alumnos entre las competencias más conocidas."],
        rol: "Diseñador UX/UI",
        tiempo: "2 meses",
        team: "10 back - 6 front - 1 Qa tester - 2 UX/UI",
        tecnologias: [
            require("../assets/img/programasYEst/figma.png"),
            require("../assets/img/programasYEst/adobe-photoshop.png"),
            require("../assets/img/programasYEst/adobe-lightroom.png"),
            require("../assets/img/programasYEst/premier-pro.png"),
        ],
        portada: require("../assets/img/portafolio/PRO-B.webp"),
        presentacion: "https://www.behance.net/gallery/179332465/PROgrama",
    },
    {
        titulo: "INDEMNIZAR",
        desc: [" Consultoria Jurídica, especializada en la gestión eficaz de indemnizaciones por cualquier tipo de daño. Busca informar a los usuarios de sus derechos y mostrar una manera facil de solucionar sus problemas.", "Nuestros objetivos fueron: simplificar el proceso en el cual se pide una consulta juridica, aumentando el nivel de solicitudes en un 68%."],
        rol: "Diseñador UX/UI",
        tiempo: "4 meses",
        team: "1 full stack - 1 UX/UI",
        tecnologias: [
            require("../assets/img/programasYEst/figma.png"),
            require("../assets/img/programasYEst/adobe-photoshop.png"),
            require("../assets/img/programasYEst/ilustrador-adobe.png"),
            require("../assets/img/programasYEst/adobe-lightroom.png"),
            require("../assets/img/programasYEst/premier-pro.png"),
        ],
        presentacion: "",
        portada: require("../assets/img/portafolio/INDEMNIZAR-B.webp"),
    },
    {
        titulo: "EMD",
        desc: ["Agencia y academia de modelos, lider en el norte de argentina. More Talent, more impact: esta agencia busca promover todos los talentos artisticos sin importar la forma del cuerpo, resaltando la actitud en las personas.", "Nuestros objetivos fueron: empatizar con el modelo, logrando entender sus miedos y animarlos a una nueva aventura."],
        rol: "Diseñador UX/UI",
        tiempo: "4 meses",
        team: "3 back - 1 front - 1 Qa tester - 1 UX/UI",
        tecnologias: [
            require("../assets/img/programasYEst/figma.png"),
            require("../assets/img/programasYEst/adobe-photoshop.png"),
            require("../assets/img/programasYEst/adobe-lightroom.png"),
            require("../assets/img/programasYEst/premier-pro.png"),
        ],
        presentacion: "",
        portada: require("../assets/img/portafolio/EMD-B.webp"),
    },
    {
        titulo: "A la orden",
        desc: ["Por el momento no estará disponible proveer información de esta plataforma, hasta que salga al mercado."],
        rol: "Diseñador UX/UI",
        tiempo: "2 meses",
        team: "3 back - 2 front - 1 Qa tester - 1 UX/UI",
        tecnologias: [
            require("../assets/img/programasYEst/figma.png"),
            require("../assets/img/programasYEst/adobe-photoshop.png"),
            require("../assets/img/programasYEst/ilustrador-adobe.png"),
            require("../assets/img/programasYEst/premier-pro.png"),
        ],
        presentacion: "",
        portada: require("../assets/img/portafolio/ALA-B.webp"),
    },
    {
        titulo: "Smarth Money School",
        desc: ["Escuela online en el rubro de las criptomonedas.", "Nuestros objetivos fueron: lograr el interes de los usuarios, consiguiendo mayor retención de los mismos, asegurandonos que 30% participen en las charlas gratuitas de la escuela."],
        rol: "Diseñador UX/UI",
        tiempo: "2 meses",
        team: "2 back - 2 front - 1 Qa tester - 2 UX/UI",
        tecnologias: [
            require("../assets/img/programasYEst/figma.png"),
        ],
        presentacion: "",
        portada: require("../assets/img/portafolio/SMS-B.webp"),
    },
    {
        titulo: "VALEN - A place for fashion",
        desc: ["E-Commers dedicada a vender los productos de los diseñadores de moda artesanales. Lugar donde estudiantes de diseño de moda o recien recibidos, pueden subir sus proyectos a modo de portafolio y poder comercializarlos a pedido.", "Nuestros objetivos fueron: aumentar las ventas de los usuarios brindando una plataforma para exibir sus productos delante de un publico interesado en una indumentaria unica."],
        rol: "Diseñador UX/UI",
        tiempo: "3 meses",
        team: "8 back - 6 front - 1 Qa tester - 2 UX/UI",
        tecnologias: [
            require("../assets/img/programasYEst/figma.png"),
            require("../assets/img/programasYEst/premier-pro.png"),
        ],
        presentacion: "",
        portada: require("../assets/img/portafolio/VALEN-B.webp"),
    },
    {
        titulo: "Hecho para 2",
        desc: ["Hecho para 2 busca evitar los desperdicios de comida, garantizando la comunicación entre vecinos, ofreciendo un plato casero a aquellos que viven solos. Garantizando que no queden sobras y rentabilizar un poco los gastos alimenticios de la casa.", "Nuestros objetivos fueron: lograr que los usuarios adopten la APP de manera tal que se reduzca el desperdicio de alimentos en un 70%."],
        rol: "UX Writer",
        tiempo: "3 meses",
        team: "1 UX Writer (Proyecto Propio)",
        tecnologias: [
            require("../assets/img/programasYEst/figma.png"),
            require("../assets/img/programasYEst/adobe-photoshop.png"),
        ],
        presentacion: "https://www.behance.net/gallery/163154879/Hecho-para-2-(-APP-web)",
        portada: require("../assets/img/portafolio/HP2-B.webp"),
    },
    {
        titulo: "Crossfy",
        desc: ["Aplicación diseñada para ayudar a los box de crossfit a dar un mejor servicio para sus usuarios, dejando que estos hagan un seguimiento de sus progresos y dando la posibilidad de anotarse a las clases.", "Nuestros objetivos fueron: cambiar la Arquitectura de la Información, mejorando la interacción con los usuarios, y modificar la interacción con los usuarios por una más motivadora y amigable, para que los usuarios se sientan interesados en anotar sus progresos, aumentando las interacciónes con la aplicación."],
        rol: "Diseñador UX/UI",
        tiempo: "3 meses",
        team: "1 UX/UI (Proyecto Propio)",
        tecnologias: [
            require("../assets/img/programasYEst/figma.png"),
            require("../assets/img/programasYEst/adobe-photoshop.png"),
            require("../assets/img/programasYEst//ilustrador-adobe.png"),
            require("../assets/img/programasYEst/adobe-lightroom.png"),

        ],
        presentacion: "https://www.behance.net/gallery/148706463/rediseno-UXUI",
        portada: require("../assets/img/portafolio/Crossfy-B.webp"),
    },
    {
        titulo: "Apoyo",
        desc: ["Aplicacion movil para contratar servicio de limpieza a tu hogar o comercio. Esta aplicación busca dár la oportunidad de que gente trabajadora tenga mayor acceso a trabajos, manteniendo su agenda organizada.", "Nuestros objetivos fueron: Garantizar una comunicación fluida centrada en lo importante a la hora de contratar personal de limpieza, acompañando con funciones que ayuden a tener las agendas optimizadas y garantizando transparencia."],
        rol: "Diseñador UX/UI",
        tiempo: "3 meses",
        team: "1 UX/UI (Proyecto Propio)",
        tecnologias: [
            require("../assets/img/programasYEst/figma.png"),
            require("../assets/img/programasYEst/adobe-photoshop.png"),
            require("../assets/img/programasYEst//ilustrador-adobe.png"),
        ],
        presentacion: "https://www.behance.net/gallery/135660083/Proyecto-final-Robles-Vega-Coder-house-2022",
        portada: require("../assets/img/portafolio/APOYO-B.webp"),
    },
]

const experiencia = [
    {
        eT1: "Hecho x Nosotros",
        eT2: "UX Researcher",
        eT3: "Desde: Julio/2023 Hasta: Enero/2024",
        eDesc: [
            "Desarrollar el procedimiento de investigación plasmado en trello.",
            "Crear encuestas y realizar entrevistas a usuarios para obtener información cualitativa y cuantitativa.",
            "Planificar una nueva arquitectura de información basada en los resultados obtenidos en la Card-Sorting y Treetesting.",
            "Realicé pruebas A/B para el sitio web de la empresa, aumentando el puntaje de usabilidad de la versión anterior del sitio en un 78%.",
        ],
        aprendi: [
            "Como trabajar con un equipo internacional en inlges.",
            "A Demostrar la valia de la investigación para cumplir las metas del producto.",
            "A cambiar de rol por el puesto más indispensable a ocupar."
        ],
        programas: [
            require("../assets/img/programasYEst/figma.png"),
            require("../assets/img/programasYEst/adobe-photoshop.png"),
            require("../assets/img/programasYEst/ilustrador-adobe.png"),
        ],
        sSkills: [
            "Trabajo en equipo.",
            "Capacidad de análisis.",
            "Resolución de problemas.",
            "Liderazgo.",
            "Comunicación efectiva.",
            "Design Thinking.",
            "Empatizar con el usuario.",
            "Google Analitics.",
            "English.",
        ],
    },
    {
        eT1: "Coder House",
        eT2: "Tutor UX/UI",
        eT3: "Desde: Diciembre/2023 Hasta: *Presente*",
        eDesc: [
            "Lidere al equipo de UX/UI para completar con éxito múltiples proyectos, cada uno en el plazo de 1 mes, cada equipo connformado entre 12 a 20 personas.",
            "Definí las metas en el equipo UX y establecí el MVP para comenzar el proyecto en par al equipo de programación.",
            "Planifiqué la ruta de investigación UX/UI y definí los trabajos a realizar de acorde a las habilidades del equipo.",
            "Diseñe wireframes en baja, capaz de poner a prueba para tener obtener resultados.",
            "Diseñe la presentación del producto para el stakeholder para mostrar los resultados positivos.",
        ],
        aprendi: [
            "A Demostrar la importancia de los estudios UX.",
            "Mejore mi ojo critico con base a objetivos y diseño.",
            "A Comunicar ideas y experiencias.",
        ],
        programas: [
            require("../assets/img/programasYEst/figma.png"),
        ],
        sSkills: [
            "Trabajo en equipo.",
            "Capacidad de análisis.",
            "Resolución de problemas.",
            "Comunicación efectiva.",
            "Aprender nuevas habilidades.",
            "Capacidad para enseñar.",
            "Empatizar con el usuario.",
        ],
    },
    {
        eT1: "No Country",
        eT2: "Diseñador UX/UI - Team Leader",
        eT3: "Desde: Oct/2022 Hasta: Abril/2023",
        eDesc: [
            "Lidere al equipo de UX/UI para completar con éxito múltiples proyectos, cada uno en el plazo de 1 mes, cada equipo connformado entre 12 a 20 personas.",
            "Definí las metas en el equipo UX y establecí el MVP para comenzar el proyecto en par al equipo de programación.",
            "Definí las metas en el equipo UX y establecí el MVP para comenzar el proyecto en par al equipo de programación.",
            "Diseñe wireframes en baja, capaz de poner a prueba para tener obtener resultados.",
            "Diseñe la presentación del producto para el stakeholder para mostrar los resultados positivos.",
        ],
        aprendi: [
            "A trabajar con equipos altamente dinamicos y de muchas personas.",
            "A priorizar un MVP amoldable a las necesidades.",
            "A Trabajar en mis habilidades creando Story telling."
        ],
        programas: [
            require("../assets/img/programasYEst/figma.png"),
            require("../assets/img/programasYEst/adobe-photoshop.png"),
            require("../assets/img/programasYEst/ilustrador-adobe.png"),
            require("../assets/img/programasYEst/premier-pro.png"),
        ],
        sSkills: [
            "Trabajo en equipo.",
            "Capacidad de análisis.",
            "Resolución de problemas.",
            "Metodologia Scrum.",
            "Liderazgo.",
            "Comunicación efectiva.",
            "Aprender nuevas habilidades.",
            "Capacidad para enseñar.",
            "Design Thinking.",
            "Empatizar con el usuario.",
        ],
    },
    {
        eT1: "ABOVE (marca freelance)",
        eT2: "Diseñador UX/UI",
        eT3: "Desde: Abril/2022 Hasta: *Presente*",
        eDesc: [
            "Planear Proceso de UXreserch con el fin de crear hipótesis que lograrán un producto innovador y competente.",
            "Realización de user testing para recopilar painpoint y evaluar la arquitectura de la información.",
            "Basándonos en los resultados del estudio, crear hipótesis e implementar cambios en el diseño, considerando las necesidades del stakeholder.",
            "Diseñar pantallas responsive de alta fidelidad.",
            "Creación de guías de estilo graficá, para mantener una marca consistente en todos los productos.",
        ],
        aprendi: [
            "A optimizar mis tiempos.",
            "A Crear equipos de proyecto con habilidades especificas.",
            "A amoldar el diseño con respecto a las necesidades del Stakeholder."
        ],
        programas: [
            require("../assets/img/programasYEst/figma.png"),
            require("../assets/img/programasYEst/adobe-photoshop.png"),
            require("../assets/img/programasYEst/ilustrador-adobe.png"),
            require("../assets/img/programasYEst/adobe-lightroom.png"),
            require("../assets/img/programasYEst/premier-pro.png"),
            require("../assets/img/programasYEst/rhinos.png"),
            require("../assets/img/programasYEst/scope.png"),
            require("../assets/img/programasYEst/unreal.png"),
        ],
        sSkills: [
            "Trabajo en equipo.",
            "Capacidad de análisis.",
            "Resolución de problemas.",
            "Metodologia Scrum.",
            "Liderazgo.",
            "Comunicación efectiva.",
            "Aprender nuevas habilidades.",
            "Pruebas de usabilidad.",
            "Design Thinking.",
            "Empatizar con el usuario.",
        ],
    },
]

export {proyectos, experiencia};